import type { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import type { Color } from '#src/style/types.ts';

import { Cursor } from './Cursor/index.tsx';

const Bar = styled.div`
  border-radius: var(--unit);
  background-color: var(--c-bar-background, var(--c-nd-200));
  position: relative;
`;
const Sections = styled(Horizontal).attrs({ gap: 0 })`
  position: relative;
  isolation: isolate;
`;
const Section = styled.div`
  height: calc(5 * var(--unit));
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: var(--half-unit);
  color: var(--c-nl-500);

  &:first-of-type {
    border-top-left-radius: var(--unit);
    border-bottom-left-radius: var(--unit);
  }
  &:last-of-type {
    border-top-right-radius: var(--unit);
    border-bottom-right-radius: var(--unit);
  }
`;

export type SectionType = {
  width?: string;
  content?: ReactNode;
  background?: Color;
};

const StyledCursor = styled(Cursor)`
  z-index: 1;
  position: absolute;
  top: calc(-1 * var(--intermediate-unit));
  transform: translateX(50%);
`;

export const SectionsBar = ({
  sections,
  cursorProps,
}: {
  sections: SectionType[];
  cursorProps?: {
    color: Color;
    rightPosition: string;
  };
}) => {
  return (
    <Bar>
      <Sections>
        {sections.map(({ width, content, background }, index) => (
          <Section
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            style={
              {
                width,
                flexGrow: width ? 0 : 1,
                background,
              } as CSSProperties
            }
          >
            {content}
          </Section>
        ))}
      </Sections>
      {!!cursorProps && (
        <StyledCursor
          color={cursorProps?.color}
          style={{
            right: cursorProps.rightPosition,
          }}
        />
      )}
    </Bar>
  );
};
